import React, { useEffect, useState } from 'react';
import { useFormik } from 'formik';
import Loader from '../../../components/Loader/Loader';
import SelectFild from '../../../components/SelectFild/SelectFild';

import { postPreventingActionPlan } from '../../../apiservices/ApiServices';

const PreventingActionPlan = ({ details, postUpdateData, toast }) => {
    const [isLoadings, setLoadings] = useState(false);
    const emptyStatement = {
        id: '',
        sub_department_id: '',
        action: '',
        deadline: '',
        responsible: '',
        escalation: '',
        display_order: 0,
    };

    const mapApiDataToFormikValues = (apiData) => {
        return apiData?.prevent_action_plan?.map(item => ({
            id: item.id,
            sub_department_id: item.sub_department_id,
            action: item.action,
            deadline: item.deadline,
            responsible: item.responsible,
            escalation: item.escalation,
            display_order: item.display_order,
        })) || [];
    };

    const [initialFormikValues, setInitialFormikValues] = useState({
        preventingAction: [emptyStatement]
    });

    useEffect(() => {
        if (details?.prevent_action_plan?.length) {
            const prefill = mapApiDataToFormikValues(details);
            setFieldValue('preventingAction', prefill);
        }
    }, [details]);

    const addStatement = () => {
        setFieldValue('preventingAction', [...values.preventingAction, { ...emptyStatement }]);
    };

    const removeStatement = (index) => {
        const updated = values.preventingAction.filter((_, i) => i !== index);
        setFieldValue('preventingAction', updated);
    };

    const transformFormValuesToPostData = (values) => {
        return {
            incident_header_id: details?.header_id,
            action_plans: values.preventingAction.map((item, index) => ({
                id: item.id,
                sub_department_id: item.sub_department_id,
                action: item.action,
                deadline: item.deadline, // Format should already be "YYYY/MM/DD"
                responsible: item.responsible,
                escalation: item.escalation,
                display_order: item.display_order || index,
            })),
        };
    };

    const postPreventingActionPlans = async (postdata) => {
        setLoadings(true);
        try {
            const res = await postPreventingActionPlan(postdata);
            toast.success(res.data.message);
            postUpdateData();
        } catch (error) {
            toast.error(error?.response?.data?.message || 'Something went wrong');
        } finally {
            setLoadings(false);
        }
    };
    const formik = useFormik({
        iinitialValues: {
            preventingAction: [emptyStatement]
        },
        validationSchema: '',
        initialValues: initialFormikValues,
        enableReinitialize: true,
        onSubmit: async (values) => {
            const postdata = transformFormValuesToPostData(values);
            await postPreventingActionPlans(postdata);
            console.log('postdata', postdata);
        },
    });
    const { values, handleSubmit, setFieldValue, handleBlur } = formik;

    return (
        <>
            <div className="form-box">
                <form onSubmit={handleSubmit} autoComplete="off">
                    <div className="fieldset preventing_action_plan">
                        <h1>Preventive Action Plan</h1>
                        <div className="formsBox">
                            <div className="table-responsive">
                                <table className="table">
                                    <thead>
                                        <tr>
                                            <th>Dept.</th>
                                            <th>Action</th>
                                            <th>Deadline</th>
                                            <th>Responsible</th>
                                            <th>Escalation</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {values.preventingAction.map((actionPlan, index) => (
                                            <tr key={index}>
                                                <td>
                                                    <div className="action_btn">
                                                        <button type="button" className="btn addbtn" onClick={addStatement}>+</button>
                                                        {values.preventingAction.length > 1 && (
                                                            <button type="button" className="btn addremove" onClick={() => removeStatement(index)}>-</button>
                                                        )}
                                                    </div>

                                                    <SelectFild
                                                        Firstop="Select Department"
                                                        selectName={`preventingAction[${index}].sub_department_id`}
                                                        options={[
                                                            { name: 'GSE Maint.', id: '1' },
                                                            { name: 'Ramp Ops', id: '2' },
                                                            { name: 'Safety', id: '3' },
                                                            { name: 'Training', id: '4' },
                                                            { name: 'Security', id: '5' },
                                                        ]}
                                                        value={actionPlan.sub_department_id}
                                                        onChange={(selectedOption) =>
                                                            setFieldValue(`preventingAction[${index}].sub_department_id`, selectedOption?.value || "")
                                                        }
                                                        onBlur={handleBlur}
                                                    />
                                                </td>
                                                <td>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        autoComplete="off"
                                                        value={actionPlan.action}
                                                        onChange={(e) =>
                                                            setFieldValue(`preventingAction[${index}].action`, e.target.value)
                                                        }
                                                    />
                                                </td>
                                                <td>
                                                    <input
                                                        type="date"
                                                        className="form-control"
                                                        autoComplete="off"
                                                        value={actionPlan.deadline}
                                                        onChange={(e) =>
                                                            setFieldValue(`preventingAction[${index}].deadline`, e.target.value)
                                                        }
                                                    />
                                                </td>
                                                <td>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        autoComplete="off"
                                                        value={actionPlan.responsible}
                                                        onChange={(e) =>
                                                            setFieldValue(`preventingAction[${index}].responsible`, e.target.value)
                                                        }
                                                    />
                                                </td>
                                                <td>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        autoComplete="off"
                                                        value={actionPlan.escalation}
                                                        onChange={(e) =>
                                                            setFieldValue(`preventingAction[${index}].escalation`, e.target.value)
                                                        }
                                                    />
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div className="button-boxs grid pb-2">
                            <button type="submit" className="btn btn-orange">Submit</button>
                        </div>
                    </div>
                </form>
            </div>
            {isLoadings ? <Loader /> : null}
        </>
    );
}

export default PreventingActionPlan